import React from "react";
import anime from "animejs";
import IconArrow from "./Icons/IconArrow";

export default props => (
  <nav
    tabIndex={0}
    className="back-button"
    onClick={props.handleMenuClick}
    onKeyPress={props.handleMenuClick}
    onSelect={props.handleMenuClick}
    onMouseEnter={() =>
      anime({
        targets: ".arrow-actual",
        scale: 1.1,
        duration: 200,
        easing: "easeOutSine"
      })
    }
    onMouseLeave={() =>
      anime({
        targets: ".arrow-actual",
        scale: 0.9,
        duration: 200,
        easing: "easeOutSine"
      })
    }
  >
    <IconArrow width={"100px"} height={"100px"} color={props.color} />
  </nav>
);



// WEBPACK FOOTER //
// ./src/components/Menu.js